/**
 * Created by idea on 03/07/2017.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';

import { BreadcrumbModule } from './breadcrumb/breadcrumb.module';
import { FooterModule } from './footer/footer.module';
import { HeaderModule } from './header/header.module';
import { NavigationModule } from './navigation/navigation.module';
import { ModalsModule } from './modals/modals.module';
import { FlashMessagesModule } from 'angular2-flash-messages';

import { adminComponent } from './layouts/admin.component';
import { basicComponent } from './layouts/basic.component';
import { blankComponent } from './layouts/blank.component';
import { nomenuComponent } from './layouts/nomenu.component';
import { MytabModule } from './mytab/mytab.module';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ComponentsModule } from '../components/component.module';

@NgModule({
  declarations: [adminComponent, blankComponent, basicComponent, nomenuComponent],
  imports: [
    BrowserModule,
    RouterModule,
    BreadcrumbModule,
    FooterModule,
    HeaderModule,
    NavigationModule,
    ModalsModule,
    FlashMessagesModule,
    MytabModule,
    FormsModule,
    TooltipModule.forRoot(),
    ComponentsModule,
  ],
  exports: [adminComponent, blankComponent, basicComponent, nomenuComponent],
})
export class LayoutModule {}



// WEBPACK FOOTER //
// ./src/app/layout/layout.module.ts